import Script from "next/script";
import { useEffect, useRef, useState } from "react";
import styles from "./ClearPayMessage.module.scss";
import { RuntimeConfig } from "@/types/types";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

const ClearPayMessageEvent = {
  CLEAR_PAY_MESSAGE_BUTTON_CLICK: "CLEAR_PAY_MESSAGE_BUTTON_CLICK",
};

type Props = {
  skuId: string;
  currentPrice?: string;
  isSelected: boolean;
  runtimeConfig: RuntimeConfig;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "square-placement": {
        "data-mpid": string;
        "data-placement-id": string;
        "data-page-type": string;
        "data-amount"?: string;
        "data-currency": string;
        "data-consumer-locale": string;
        "data-item-skus": string;
        "data-is-eligible": string;
      };
    }
  }
}

export const ClearPayMessageUI = ({
  skuId,
  currentPrice,
  isSelected,
  runtimeConfig,
}: Props) => {
  const [amount, setAmount] = useState<string | undefined>("");
  const cp = useRef();
  useEffect(() => {
    if (isSelected) {
      setAmount(currentPrice);
    }
  }, [isSelected, currentPrice]);

  useEffect(() => {
    const handleDispatchMonetateQEvent = (e: MouseEvent) => {
      if (
        e.target &&
        e.target instanceof Element &&
        e.target?.nodeName === "SQUARE-PLACEMENT"
      ) {
        dispatchMonetateQEvent(
          ClearPayMessageEvent.CLEAR_PAY_MESSAGE_BUTTON_CLICK,
        );
      }
    };

    document.addEventListener("click", handleDispatchMonetateQEvent);

    return () => {
      document.removeEventListener("click", handleDispatchMonetateQEvent);
    };
  }, []);

  useEffect(() => {
    const cp = document.querySelector("square-placement");
    if (cp && cp.shadowRoot) {
      const button = cp.shadowRoot.querySelector("button");
      if (button) button.style.maxWidth = "75px";
    }
  }, [cp]);

  const ClearPaySquareElement = () => (
    <square-placement
      data-mpid={runtimeConfig.clearPayMPID}
      data-placement-id={runtimeConfig.clearPayPlacementId}
      data-page-type="product"
      data-amount={amount}
      data-currency="GBP"
      data-consumer-locale="UK"
      data-item-skus={skuId}
      data-is-eligible="true"
    />
  );

  return (
    <>
      <Script async src={runtimeConfig?.clearPayScriptURL} />
      <div
        className={styles.clearPayMessage__block}
        data-testid="clearpay-message-container"
        data-component="ClearPayMessage"
        id="ClearPayMessage"
      >
        <ClearPaySquareElement />
        <p className={styles.terms}>18+, T&C apply.</p>
      </div>
    </>
  );
};
